import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import {
    CreateTabelaHorariosSchema,
    TabelaHorarios,
    tabelaHorarios,
} from 'service/api'
import { toast } from 'sonner'
import { updateRascunho } from 'templates/Cadastro/Funcionarios/organismos/modals/Adicionar'
import { diasTabelaHorario } from '../constants/dias-tabela-horario'
import { CanSubmitProvider, useCanSubmit } from '../context/CanSubmitContext'
import FormTabelaHorario from '../forms/FormTabelaHorario'

function AdicionarTabelaHorariosContent() {
    const { mutateAsync, isLoading } = tabelaHorarios.mutations.useCreate({
        invalidateQuery: true,
    })
    const { canSubmit } = useCanSubmit()

    const handleSubmit: SubmitHandler<TabelaHorarios> = async data =>
        mutateAsync(data, {
            onSuccess: res => {
                updateRascunho({ tabelaHorarioId: res.id })
                toast.success('Tabela adicionada com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            height="auto"
            width="62rem"
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={CreateTabelaHorariosSchema}
            defaultValues={{
                horarios: diasTabelaHorario.map(it => ({
                    label: it,
                    Tot: '00:00',
                })),
                tolerancias: {
                    entradaAntes: '00:00',
                    entradaDepois: '00:00',
                    saidaAntes: '00:00',
                    saidaDepois: '00:00',
                    toleranciaTurno: '00:00',
                    toleranciaDia: '00:00',
                },
                tempoPausas: '00:00',
                totSem: '00:00',
            }}
            open={hasPermission(['create', 'TabelaDeHorários'])}
        >
            <Dialog.Title>Adicionar tabela de horários</Dialog.Title>
            <Dialog.Content dividers>
                <FormTabelaHorario />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton
                    closeOnSubmit
                    disabled={!canSubmit}
                />
            </Dialog.Actions>
        </Dialog.Root>
    )
}

export default function AdicionarTabelaHorarios() {
    return (
        <CanSubmitProvider>
            <AdicionarTabelaHorariosContent />
        </CanSubmitProvider>
    )
}
